import { useClipboard } from "../../hooks/useClipboard";
import { Toaster } from "react-hot-toast";

const LinkCopyButton = ({ path }) => {
  const { copy } = useClipboard();
  const copyUrl = window.location.origin + path;


  return (
    <>
        <div className="share-button link-copy" onClick={() => copy(copyUrl)}>
            <img src="/assets/images/others/icon-link.svg"  />
        </div>
        <Toaster position="top-center" />
    </>
  );
}
export default LinkCopyButton
